<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Création de commande</h2>
            <form @submit.prevent="createColis">
            <fieldset class="uk-fieldset">
                <div class="uk-margin">
                   <!--  <label>Choisir une boutique</label> -->
                    <autocomplete :search="search"
                    placeholder="Rechercher une boutique"
                    aria-label="Rechercher une boutique"
                    :get-result-value="getResultValue"
                    @submit="selectBoutique"
                    ></autocomplete>
                    <!-- <select class="uk-select" v-model="commande.client_name">
                        <option v-for="boutique in boutiques" :key="boutique.id" :value="boutique.nom_boutique" v-on:click="selectBoutique(boutique.uuid)">{{boutique.nom_boutique}}</option>
                    </select>  -->
                    <!-- <v-select 
                        :options="boutiques" 
                        :reduce="option => commande.client_name"
                        :get-option-label="(option) => option.nom_boutique"
                        @input="selectBoutique(option.uuid)"
                        :required="!commande.client_name">
                        <slot name="no-options">Aucune boutique, pour l'instant.</slot>
                    </v-select> -->
                 </div>
                <div class="uk-margin">
                    <label>Lieu de depart</label>
                    <input class="uk-input" type="text" v-model="commande.depart_address" :placeholder="laboutique.adresse" disabled>
                </div>
                <div class="uk-margin">
                    <label>Contact de depart</label>
                    <input class="uk-input" type="number" v-model="commande.client_phone" :placeholder="laboutique.contact_boutique" disabled>
                </div>
                <div class="uk-margin">
                    <input class="uk-input" type="text" v-model="commande.dest_address" placeholder="Lieu de destination" required>
                </div>
                
                <div class="uk-margin">
                    <input class="uk-input" type="number" v-model="commande.dest_contact" placeholder="Contact de destination" required>
                </div>
                <div class="uk-margin">
                    <input class="uk-input" type="text" v-model="commande.nature" placeholder="Nature du colis" required> 
                </div>
                <div class="uk-margin">
                <label>Tarifs de la livraison (en FCFA)</label>
                    <input class="uk-input" type="number" v-model="commande.montant" placeholder="prix de la livraison" required>
                </div>
                <div class="uk-margin">
                <label>Valeur de colis (en FCFA)</label>
                    <input class="uk-input" type="number" v-model="commande.valeur" placeholder="prix de la livraison" required>
                </div>
            </fieldset>
       <div class="d-flex justify-content-center">
            <button class="btn btn-round my-3 border-0 px-5" style="background-color:#0E93FF; color:#fff;  font-size:1em !important; ">Enregistrer</button>
       </div>
        </form>
            </div>
        </div>
    </div>
</template>
<script>
  import { db, dbstore, auth } from '../../main';
  import Swal from "sweetalert2";
export default {
    data(){
        return{
            commande: {
                client_name: "",
                client_phone: "",
                colis_type: "envoi",
                created_at:"",
                depart_address:"",
                dest_address:"",
                dest_contact:"",
                id_colis:"",
                livreur_id:"",
                montant:0,
                valeur:0,
                nature:"",
                categorie:"boutique",
                payment_method:"cash",
                statut:"attente"
            },
            boutiques:[],
            laboutique:[],
        }
        
    },
    created(){
        const current = new Date();
      console.log(current.getUTCDate().toString())
      const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
      const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
      const dateTime = date +' '+ time;
      const created_at = dateTime
        dbstore.collection('boutiques').onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            this.boutiques.push( doc.data());
        })
    });
    },
    methods: {
        search(input) {
      if (input.length < 1) { return [] }
      return this.boutiques.filter(uneboutique => {
        return uneboutique.nom_boutique.toLowerCase()
          .startsWith(input.toLowerCase())
      })
    },
    getResultValue(result) {
      return result.nom_boutique
    },
    selectBoutique(result){
    dbstore.collection('boutiques').where("uuid", '==', result.uuid).onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
        this.laboutique = doc.data();
    });
    });
    },
    createColis(event){
      
    var today = new Date();
    var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var created_at = date+' '+time

      const colis = db.ref('Colis Requetes').push({
        client_name: this.laboutique.nom_boutique,
        client_phone: this.laboutique.contact_boutique,
        colis_type: "envoi",
        created_at:created_at,
        depart_address:this.laboutique.adresse,
        dest_address:this.commande.dest_address,
        dest_contact:this.commande.dest_contact,
        id_colis:"",
        livreur_id:"", 
        montant:Number(this.commande.montant),
        valeur:Number(this.commande.valeur),
        nature:this.commande.nature,
        payment_method:this.commande.payment_method,
        statut:this.commande.statut,
        categorie:this.commande.categorie,
        boutique_matricule : this.laboutique.uuid,
        agent_id: auth.currentUser.uid
      }) 
      db.ref('Colis Requetes').child(colis.key).child('id_colis').set(colis.key) 
      this.$router.push({ path: "/admin/livraison/encours"});
      event.target.reset();
      event.preventDefault(); Swal.fire({
            position: "center",
            icon: "success",
            title: "créer avec succès",
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
          }); 
      
    },
    }
}
</script>